"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosOilBlendingThemeSchema = exports.APosOilBlendingThemeBodySchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../../common/timestamps.schema");
const id_schema_1 = require("../../../common/id.schema");
const background_schema_1 = require("./background.schema");
const mood_schema_1 = require("./mood.schema");
const banner_schema_1 = require("./banner.schema");
/**
 * Body shared by the editable draft and the published live snapshot.
 * Same shape — the wrapper (APosOilBlendingThemeSchema) holds both copies.
 */
exports.APosOilBlendingThemeBodySchema = zod_1.z.object({
    banner: banner_schema_1.APosThemeBannerSchema,
    moods: zod_1.z.array(mood_schema_1.APosThemeMoodSchema).max(20).default([]),
    pageBackground: background_schema_1.APosThemeBackgroundSchema.default({
        type: 'solid',
        color: '#FAF8F5',
    }),
    cardAspect: zod_1.z.enum(['3:4', '4:5', '1:1']).default('4:5'),
    cardCornerRadius: zod_1.z.number().int().min(0).max(48).default(24),
    // Bumped on every successful save of draft / publish of live. Clients use
    // the live version on every heartbeat to know whether to refetch the theme.
    version: zod_1.z.number().int().min(0).default(0),
});
/**
 * Module 29 — Oil Blending. Kiosk theme record.
 * One row per tenant. PK = TENANT#{tenantId}, SK = THEME#oil-blending.
 *
 * Draft and live live in the same record so a single GET serves both the
 * editor (needs both, to show "5 unpublished changes") and the kiosk
 * (needs only `live`).
 */
exports.APosOilBlendingThemeSchema = zod_1.z
    .object({
    tenantId: id_schema_1.TenantIdSchema,
    draft: exports.APosOilBlendingThemeBodySchema,
    live: exports.APosOilBlendingThemeBodySchema,
    publishedAt: zod_1.z.string().datetime().optional(),
})
    .merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=theme.schema.js.map